import { useExperiment } from "@statsig/react-bindings";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import i18n from "../i18n";
import syncCalBannerAR2x from "../img/sync-cal-1400x180-ar.png";
import syncCalBannerEN2x from "../img/sync-cal-1400x180-en.png";
import syncCalBannerAR1x from "../img/sync-cal-640x100-ar.png";
import syncCalBannerEN1x from "../img/sync-cal-640x100-en.png";
import EcalButton from "./EcalButton";

const Banner = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.space[4]} 0;
`;

const StyledImage = styled.img`
  display: block;
  width: 100%;
`;

const ECalBanner = () => {
  const { t } = useTranslation();

  // gtmClass is the Click Class we send when we push to
  // the dataLayer via the handleEcalButtonClick util
  const gtmClass = "banner";

  const banner1x =
    i18n.language === "ar" ? syncCalBannerAR1x : syncCalBannerEN1x;
  const banner2x =
    i18n.language === "ar" ? syncCalBannerAR2x : syncCalBannerEN2x;

  // useExperiment returns an object with a .get() method to retrieve parameter values
  const experiment = useExperiment("calendar_cta_banner");

  // Get the boolean value from the experiment (assuming it's configured as a boolean parameter)
  // If calendar_cta_banner is a feature gate, use useGateValue instead
  const showBanner = experiment.get("display_calendar_top", false);

  if (!showBanner) {
    return null;
  }

  return (
    <Banner className="Banner">
      <EcalButton variant="unstyled" gtmClass={gtmClass}>
        <StyledImage
          src={banner1x}
          srcSet={`${banner1x} 640w, ${banner2x} 1400w`}
          sizes="(max-width: 640px) 100vw, 1400px"
          alt={t("fixtures.syncToCalendar", "Add fixtures to your calendar")}
        />
      </EcalButton>
    </Banner>
  );
};

export default ECalBanner;
